<template>
    <button @click="$emit('click')" :class="[type, {blank, transparent}]">
        <slot/>
    </button>
</template>

<script>
export default {
    name: "Button",
    props: {
        type: {
            type: String,
            default: 'primary'
        },
        blank: {
            type: Boolean,
            default: false,
        },
        transparent: {
            type: Boolean,
            default: false,
        }
    }
}
</script>

<style lang="scss">
button {
  transition-property: color, background-color;
  transition-duration: 250ms;

  svg path {
    transition: fill 250ms;
  }

  &.primary {
    background-color: $primary;
    color: $white;
    @include svgFill($white);

    &:hover:not(:active) {
      background-color: $primaryDark;
    }

    &.transparent {
      background-color: $primaryTransparent;
      color: $primary;
      @include svgFill($primary);

      &:hover {
        background: rgba($primary, 0.3);
      }

      &:active {
        background-color: $primary;
        color: $white;
        @include svgFill($white);
      }
    }

    &.blank {
      background: none;
      color: $primary;
      @include svgFill($primary);

      &:hover:not(:active) {
        background: none;
        color: $primaryDark;
        @include svgFill($primaryDark);
      }
    }
  }

  &.secondary {
    background-color: $secondary;
    color: $white;
    @include svgFill($white);

    &:hover:not(:active) {
      background-color: $secondaryDark;
    }

    &.blank {
      background: none;
      color: $secondary;
      border: solid 2px $secondary;
      @include svgFill($secondary);

      &:hover {
        background: none;
        border-color: $secondaryDark;
        color: $secondaryDark;
        @include svgFill($secondaryDark);
      }

      &:active {
        background-color: $secondary;
        border-color: $secondary;
        color: $white;
        @include svgFill($white);
      }
    }
  }


}
</style>